import { Box, Button, ColumnConfig, DataTable, Layer, Text, TextInput } from "grommet";
import { AxiosError } from "axios";
import { Observer, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useStore } from "../../../../../Hooks/useStore";
import { toJS } from "mobx";
import { Mixpanel } from "../../../../../util/Helper";
import DisableSidebar from "../../../../../assets/close_small.svg";
import { userStore } from "../../../../../store/UserStore";
import "./DisableRightSideBar.css"
import usersService from "../../screens/IAM/Users/users.service";
import { useUser } from "../../../context/User/UserContext";

  
  function DisableRightSidebar (){
    const {user, setUser} = useUser();

    const [inputValue, setInputValue] = useState('');
    

    const handleInputChange = (event:any) => {
      setInputValue(event.target.value);
    };
    const handleSubmit = () => {
      
      console.log('Form submitted with value:', inputValue);

    };

   
  
const {rootStore}=useStore();
// const handleUserShowDisableConfirmation = () => {
//   this.userShowDisableConfirmation = newVal;
// }

return(

    <Layer className="disable-user-sidebar-container"
    style={{borderRadius: "12px 0px 0px 0px",width:"500px", height:"100%"}}
    full="vertical"
    position="right"
    // onEsc={() => {
    //     Mixpanel.track("web close " + submitButtonTitle);
    //     onCancel();
    // }}
    >
     <Box
        fill
        style={{ minWidth: "378px",borderRadius: "12px 0px 0px 0px", maxWidth: "500px" }}
        flex
        flex-start
        direction="column"
        
        align="center"
      >
         <Box
        style={{borderRadius: "12px 0px 0px 0px", display:"flex",flexDirection:"row",justifyContent:"space-between"
        }}
          direction="column"
   
          as="header"
     
          background={"#E9F2FF"}
          width="100%"
          pad={"small"}
          
        >
            <Text
            style={{
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px"
            }}>Confirm</Text>
            {/* <Button 
        style={{color: "#357EFF",
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "16px"}} onClick={() => {
            Mixpanel.track("web close " );
            onCancel();
          }} ><img src={closeActionSidebar} style={{width: 20, height: 20}}/>Close</Button> */}
                <Button
                 style={{color: "#357EFF",
                 fontFamily: "Inter",
                 fontSize: "14px",
                 fontStyle: "normal",
                 fontWeight: "600",
                 lineHeight: "16px"}} onClick={() => {rootStore.adminStore.handleUserShowDisableConfirmation(false);}}><img src={DisableSidebar} style={{width: 20, height: 20}}/>
                 Close</Button>
         
        </Box>
        <Box className="disable-user-middle-container">
        <Box style={{ borderRadius: "12px 0px 0px 12px",
background: "#FFF",
display: "inline-flex",
flexDirection: "column",
alignItems: "flex-start",
gap: "16px"}}>
  <Text style={{
         color: "#4B628A",
         fontFamily: "Inter",
         fontSize: "16px",
         fontStyle: "normal",
         fontWeight: "500",
         lineHeight: "22px"
  }}>Are you sure you want to disable the user?</Text>
  <Text
     style={{
      color: "#4B628A",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "22px"
     }}
  >Please type <span style={{fontWeight:"600"}}>‘DISABLE’</span> in the field below to confirm.</Text>
   <TextInput
   type="password"
   placeholder="Enter Here"
   style={{
    color: "#333",

fontFeatureSettings: "'clig' off, 'liga' off",
fontFamily: "Inter",
fontSize: "14px",
fontStyle: "normal",
fontWeight: "500",
lineHeight: "22px",
    display: "flex",
    padding: "13px 15px",
    alignItems: "flex-start",
    gap: "10px",
    alignSelf: "stretch",
    borderRadius: "10px",
background: "#F2F8FF",
width:"84%",
boxShadow:"unset",
border:"none"
   }}
   onChange={handleInputChange}

   />
        </Box>
        <Box className="disable-user-btn">
          <Button style={{
            color: "#357EFF",
            display: "flex",
            width: "120px",
            padding: "14px 49px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "10px",
            border: "1px solid #357EFF",
            background: "#FFF",

          }}
          onClick={() => {Mixpanel.track("web_disable_user_cancel_click",{ name: user?.username });
          rootStore.adminStore.handleUserShowDisableConfirmation(false);}}
          label="Cancel"
          />
           <Button 
          label="Confirm"
          
          className={`myButton ${inputValue.toLowerCase() === 'disable' ? 'active' : 'disabled'}`}
          onClick={async() =>{
            Mixpanel.track("web_disable_user_submit_click",{ name: user?.username });
          try {
            await usersService.disableUsers(rootStore.adminStore.getSelectedusers);
            rootStore.notificationToastStore.showNotification("User disable successfully.",false, 3000);
            if (rootStore.adminStore.getUserOrgId) {
              console.log("orgID", toJS(rootStore.adminStore.getUserOrgId));
              rootStore.loadingStore.setShowLoader(true);
              usersService.getUserbyOrganizationId(rootStore.adminStore.getUserOrgId)
                .then((organization) => {
                  rootStore.adminStore.handleUsers(organization);
                  rootStore.adminStore.handleOriginalUsers(organization);
                  rootStore.loadingStore.setShowLoader(false);
                  rootStore.adminStore.handleUserShowDisableConfirmation(false);
                })
                .catch((e: AxiosError) => {
                  rootStore.loadingStore.setShowLoader(false);
                  rootStore.adminStore.handleUserShowDisableConfirmation(false);
                  rootStore.adminStore.handleUsers([]);
                  rootStore.adminStore.handleOriginalUsers([]);
                  if (e.message.includes("403")) {
                    rootStore.errorHandlingStore.displayError(
                      "ERROR: User not authorized"
                    );
                  }
                });
            } else {
              rootStore.loadingStore.setShowLoader(true);
              usersService.listUsers()
                .then((_users) => {
                  rootStore.adminStore.handleUsers(_users);
                  rootStore.adminStore.handleOriginalUsers(_users);
                  rootStore.loadingStore.setShowLoader(false);
                  rootStore.adminStore.handleUserShowDisableConfirmation(false);
                })
                .catch((e: AxiosError) => {
                  rootStore.loadingStore.setShowLoader(false);
                  rootStore.adminStore.handleUserShowDisableConfirmation(false);
                  rootStore.adminStore.handleUsers([]);
                  rootStore.adminStore.handleOriginalUsers([]);
                  if (e.message.includes("403")) {
                    rootStore.errorHandlingStore.displayError(
                      "ERROR: User not authorized"
                    );
                  }
                });
            }


          } catch (e:any) {
            if (e) {
              rootStore.errorHandlingStore.displayError(e.message);
            } else {
              rootStore.errorHandlingStore.displayError("Error occured while disabling users.");
            }
          }
          }} disabled={inputValue.toLowerCase()==="disable" ? false : true}
          
          />
        </Box>
        </Box>
      </Box>
      </Layer>
    )
    
  }
  
  export default observer(DisableRightSidebar);